import { defineMessages } from 'react-intl';

const coreTranslations = defineMessages({
    ng_core_accountSettings: {
        id: 'ng_AdminMenuItem',
        defaultMessage: 'Account settings'
    },
    ng_core_accStructure: {
        id: 'ng_accStructure',
        defaultMessage: 'Account Structure'
    },
    ng_core_accountDefaults: {
        id: 'ng_accountDefaults',
        defaultMessage: 'Account Defaults'
    },
    ng_core_alertSettings: {
        id: 'ng_alertSettings',
        defaultMessage: 'Alert Settings'
    },
    ng_core_deviceSettings: {
        id: 'ng_deviceSettings',
        defaultMessage: 'Device Settings'
    },
    ng_core_deliverySettings: {
        id: 'ng_deliverySettings',
        defaultMessage: 'Delivery Settings'
    },
    ng_core_modalityConfig: {
        id: 'ng_modlaityConfig',
        defaultMessage: 'Default Modality Configuration'
    },
    ng_core_security: {
        id: 'ng_SecrityMenuItem',
        defaultMessage: 'Security'
    },
    ng_core_branding: {
        id: 'ng_branding',
        defaultMessage: 'Branding'
    },

    ng_core_labels: {
        id: 'ng_labelMenuItem',
        defaultMessage: 'Labels'
    },
    ng_core_features: {
        id: 'ng_Features',
        defaultMessage: 'Features'
    },
    ng_core_globalCascade: {
        id: 'ng_GlobalCascade',
        defaultMessage: 'Global Cascade'
    },
    ng_core_alertLanguages: {
        id: 'ng_LangMenuItem',
        defaultMessage: 'Alert Languages'
    },
    ng_core_alertGlobalVariables: {
        id: 'ng_sidebar_alertGlobalVariables',
        defaultMessage: 'Alert Global Variables'
    },
    ng_core_alertOptions: {
        id: 'ng_core_alertOptions',
        defaultMessage: 'Alert Options'
    },
    ng_core_alertOptionsDescription: {
        id: 'ng_core_alertOptionsDescription',
        defaultMessage: 'View and manage alert options.'
    },
    ng_core_audioLibrary: {
        id: 'ng_AudioLibrary',
        defaultMessage: 'Audio Library'
    },
    ng_core_conferenceBridge: {
        id: 'ng_ConferenceBridge',
        defaultMessage: 'Conference Bridge'
    },
    ng_core_conferenceBridgeDescription: {
        id: 'ng_core_conferenceBridgeDescription',
        defaultMessage: 'Conference call participant management'
    },
    ng_core_callCenterConnect: {
        id: 'ng_Cmccc',
        defaultMessage: 'Call Center Connect'
    },
    ng_core_callForwarding: {
        id: 'ng_CallForwarding',
        defaultMessage: 'Call Forwarding'
    },
    ng_core_callList: {
        id: 'ng_core_callList',
        defaultMessage: 'Call List'
    },
    ng_core_callListDescription: {
        id: 'ng_core_callListDescription',
        defaultMessage: 'Track contact points for contacts'
    },
    ng_core_passPref: {
        id: 'ng_PassPref',
        defaultMessage: 'Password Preferences'
    },
    ng_core_forgotPass: {
        id: 'ng_ForgotPass',
        defaultMessage: 'Forgot Password'
    },
    ng_core_enterCurrentPassword: {
        id: 'ng_forgotCredentials_enterCurrentPassword',
        defaultMessage: 'Enter your current password'
    },
    ng_core_enterPassword: {
        id: 'ng_forgotCredentials_enterPassword',
        defaultMessage: 'Enter your new password'
    },
    ng_core_enterPassword_short: {
        id: 'ng_forgotCredentials_enterPassword_short',
        defaultMessage: 'Enter new password'
    },
    ng_core_confirmPassword: {
        id: 'ng_forgotCredentials_confirmPassword',
        defaultMessage: 'Confirm password'
    },
    ng_core_enterConfirmPassword: {
        id: 'ng_forgotCredentials_enterConfirmPassword',
        defaultMessage: 'Enter password again to confirm'
    },
    ng_core_factorAuthentication: {
        id: 'ng_sidebar_factorAuthentication',
        defaultMessage: '2-Factor Authentication'
    },
    ng_core_sso: {
        id: 'ng_sidebar_sso',
        defaultMessage: 'SSO'
    },
    ng_core_customDisclaimers: {
        id: 'ng_custDsclMenuItem',
        defaultMessage: 'Custom Disclaimers'
    },
    ng_core_securityMsgCenter: {
        id: 'ng_SecurityMsgCenter',
        defaultMessage: 'Security Message Center'
    },
    ng_core_protectedDataFields: {
        id: 'ng_sidebar_protectedDataFields',
        defaultMessage: 'Protected Data Fields'
    },
    ng_core_dataSubRights: {
        id: 'ng_DataSubRights',
        defaultMessage: 'Data Subject Rights'
    },
    ng_core_sharedMessageBoards: {
        id: 'ng_sharedMessageBoards',
        defaultMessage: 'Shared Message Boards'
    },
    ng_core_generalOptions: {
        id: 'ng_sidebar_generalOptions',
        defaultMessage: 'General Options'
    },
    ng_core_retrySettings: {
        id: 'ng_fba_name__retry_settings',
        defaultMessage: 'Retry Settings'
    },
    ng_core_division_ani: {
        id: 'ng_core_division_ani',
        defaultMessage: 'Division ANI'
    },
    ng_core_call_throttling: {
        id: 'ng_core_call_throttling',
        defaultMessage: 'Call Throttling'
    },
    ng_core_dataHierarchy: {
        id: 'ng_sidebar_dataHierarchy',
        defaultMessage: 'Data Hierarchy'
    },
    ng_core_permissionsUsers: {
        id: 'ng_permissionsUsers',
        defaultMessage: 'Users'
    },
    ng_core_roles: {
        id: 'menu-users-roles',
        defaultMessage: 'Roles'
    },
    ng_core_roles_and_templates: {
        id: 'menu-users-roles-and-templates',
        defaultMessage: 'Roles and Templates'
    },
    ng_core_roleTemplates: {
        id: 'ng_sidebar_roleTmpl',
        defaultMessage: 'Role Templates'
    },
    ng_core_organizationProfile: {
        id: 'ng_sidebar_organizationProfile',
        defaultMessage: 'Organization Profile'
    },
    ng_core_termsAndConditions: {
        id: 'ng_sidebar_termsAndConditions',
        defaultMessage: 'Terms and Conditions'
    },
    ng_core_customVerb: {
        id: 'ng_sidebar_customVerb',
        defaultMessage: 'Custom Verbiage'
    },
    ng_core_alertCenter: {
        id: 'ng_sidebar_alertCenter',
        defaultMessage: 'Alert Center'
    },
    ng_core_alertInbox: {
        id: 'ng_sidebar_alertInbox',
        defaultMessage: 'Alert Inbox'
    },
    ng_core_fileBasedAlert: {
        id: 'ng_sidebar_fileBasedAlert',
        defaultMessage: 'File-Based Alert'
    },
    ng_core_scheduledAlerts: {
        id: 'ng_SchdAlrtMenuItem',
        defaultMessage: 'Scheduled Alerts'
    },
    ng_core_approvals: {
        id: 'ng_sidebar_approvals',
        defaultMessage: 'Approvals'
    },
    ng_core_contactManagement: {
        id: 'ng_contactManagement',
        defaultMessage: 'Contact Management'
    },
    ng_core_schedules: {
        id: 'ng_menu-users-schedules',
        defaultMessage: 'Schedules'
    },
    ng_core_dataTools: {
        id: 'ng_sidebar_dataTools',
        defaultMessage: 'Data Tools'
    },
    ng_core_dataImport: {
        id: 'ng_sidebar_dataImport',
        defaultMessage: 'Data Import'
    },
    ng_core_selfUpdate: {
        id: 'ng_SelfUpdate',
        defaultMessage: 'Self-Update'
    },
    ng_core_update: {
        id: 'ng_core_update',
        defaultMessage: 'Update'
    },
    ng_core_selfReg: {
        id: 'ng_selfReg',
        defaultMessage: 'Account Portal'
    },
    ng_core_dashboard: {
        id: 'Control Center',
        defaultMessage: 'Control Center'
    },
    ng_core_integrations: {
        id: 'ng_integrationsMenu',
        defaultMessage: 'Integrations'
    },
    ng_core_publicFeeds: {
        id: 'ng_PublicFeeds',
        defaultMessage: 'Public Feeds'
    },

    ng_core_publicFeedsDescription: {
        id: 'ng_core_publicFeedsDescription',
        defaultMessage: 'View and manage public feeds.'
    },
    ng_core_chat: {
        id: 'ng_chat',
        defaultMessage: 'Chat'
    },
    ng_core_chatDescription: {
        id: 'ng_core_chatDescription',
        defaultMessage: 'View and manage chat.'
    },
    ng_core_guardianSDS: {
        id: 'ng_GuardianSDS',
        defaultMessage: 'Guardian SDS'
    },
    ng_core_guardianSDSDescription: {
        id: 'ng_core_guardianSDSDescription',
        defaultMessage: 'View and manage guardian SDS.'
    },
    ng_core_alertus: {
        id: 'ng_Alertus',
        defaultMessage: 'Alertus'
    },
    ng_core_alertusDescription: {
        id: 'ng_core_alertusDescription',
        defaultMessage: 'View and manage alertus.'
    },
    ng_core_apiKeys: {
        id: 'ng_apiKeys',
        defaultMessage: 'API Keys'
    },
    ng_core_apiKeysDescription: {
        id: 'ng_core_apiKeysDescription',
        defaultMessage: 'View and manage API keys.'
    },
    ng_core_reporting: {
        id: 'ng_fba_name__reporting',
        defaultMessage: 'Reporting'
    },
    ng_core_contactAccounting: {
        id: 'ng_sidebar_contactAccounting',
        defaultMessage: 'Contact Accounting'
    },
    ng_core_accountability: {
        id: 'ng_sidebar_accountability',
        defaultMessage: 'Accountability'
    },
    ng_core_alertHistory: {
        id: 'ng_sidebar_alertHistory',
        defaultMessage: 'Alert History'
    },
    ng_core_auditTrail: {
        id: 'ng_ATrailMenuItem',
        defaultMessage: 'Audit Trail'
    },
    ng_core_auditTrailDescription: {
        id: 'ng_core_auditTrailDescription',
        defaultMessage: 'View system audit trail information'
    },
    ng_core_reports: {
        id: 'ng_dpReports',
        defaultMessage: 'Reports'
    },
    ng_core_historical_reporting: {
        id: 'ng_core_historical_reporting',
        defaultMessage: 'Risk Insights'
    },
    ng_core_reportsDescription: {
        id: 'ng_core_reportsDescription',
        defaultMessage: 'Create and run custom reports'
    },
    ng_core_historical_reporting_description: {
        id: 'ng_core_historical_reporting_description',
        defaultMessage: 'Track actions, events, and changes in the risk intelligence system'
    },
    ng_core_adHocReports: {
        id: 'menu-notifications-adhoc-reports',
        defaultMessage: 'Ad Hoc Reports'
    },
    ng_core_usage: {
        id: 'ng_sidebar_usage',
        defaultMessage: 'Usage'
    },
    ng_core_usageDescription: {
        id: 'ng_core_usageDescription',
        defaultMessage: 'Track alert traffic & system usage'
    },
    ng_core_solutions: {
        id: 'ng_solutionsMenu',
        defaultMessage: 'Solutions'
    },
    ng_core_mapsAndShapes: {
        id: 'ng_sidebar_mapsAndShapes',
        defaultMessage: 'Maps & Shapes'
    },
    ng_core_mobile: {
        id: 'ng_Mobile',
        defaultMessage: 'Mobile'
    },
    ng_core_lockbox: {
        id: 'ng_sidebar_lockbox',
        defaultMessage: 'Lockbox'
    },
    ng_core_lockboxDescription: {
        id: 'ng_core_lockboxDescription',
        defaultMessage: 'Secure file storage & version control'
    },
    ng_core_eventStream: {
        id: 'ng_sidebar_eventStream',
        defaultMessage: 'EventStream'
    },
    ng_core_txtToKeyword: {
        id: 'ng_sidebar_txtToKeyword',
        defaultMessage: 'Text-to-Keyword'
    },
    ng_core_desktopAlerts: {
        id: 'ng_sidebar_desktopAlerts',
        defaultMessage: 'Desktop Alerts'
    },
    ng_core_lookOut: {
        id: 'ng_sidebar_lookOut',
        defaultMessage: 'LookOut'
    },
    ng_core_lookOutDescription: {
        id: 'ng_core_lookOutDescription',
        defaultMessage: 'Reported incidents from contacts'
    },
    ng_core_sos: {
        id: 'ng_sidebar_sos',
        defaultMessage: 'SOS'
    },
    ng_core_sosDescription: {
        id: 'ng_core_sosDescription',
        defaultMessage: 'History of reported SOS emergencies'
    },
    ng_core_ivrManager: {
        id: 'ng_IvrManager',
        defaultMessage: 'IVR Manager'
    },
    ng_core_ivrManagerDescription: {
        id: 'ng_core_ivrManagerDescription',
        defaultMessage: 'View and manage IVR manager.'
    },
    ng_core_settings: {
        id: 'ng_Settings',
        defaultMessage: 'Settings'
    },
    ng_core_shapes: {
        id: 'ng_ShapesMenuItem',
        defaultMessage: 'Shapes'
    },
    ng_core_supportAndTraining: {
        id: 'ng_supportAndTraining',
        defaultMessage: 'Support & Training'
    },
    ng_core_whatIsNewInBeta: {
        id: 'ng_sidebar_whatIsNewInBeta',
        defaultMessage: 'What’s New'
    },
    ng_core_onsolveAnnouncements: {
        id: 'ng_announcements_announcements',
        defaultMessage: 'Announcements'
    },
    ng_core_onsolveAnnouncementsTool: {
        id: 'ng_announcementsTool_title',
        defaultMessage: 'Announcements Tool'
    },
    ng_core_contactUs: {
        id: 'ng_ContUsMenuItem',
        defaultMessage: 'Contact Us'
    },
    ng_core_incidentManagement: {
        id: 'ng_core_incidentManagement',
        defaultMessage: 'Incident Management'
    },
    ng_core_resourceLibrary: {
        id: 'ng_resourceLibrary',
        defaultMessage: 'Resource Library'
    },
    ng_core_documentation: {
        id: 'ng_usermenu-documentation',
        defaultMessage: 'Documentation'
    },
    ng_core_back: {
        id: 'ng_Back',
        defaultMessage: 'Back'
    },
    ng_core_goBack: {
        id: 'ng_core_goBack',
        defaultMessage: 'Go Back'
    },
    ng_core_bulkAlerts: {
        id: 'ng_core_bulkAlerts',
        defaultMessage: 'Bulk Alerts'
    },
    ng_core_linkedAlerts: {
        id: 'ng_core_linkedAlerts',
        defaultMessage: 'Linked Alerts'
    },
    ng_core_privacyStatement: {
        id: 'ng_ftrPrivacyRequest',
        defaultMessage: 'Privacy Statement'
    },
    ng_core_copyrightNotice: {
        id: 'ng_ftrCopy',
        defaultMessage: 'Copyright Notice'
    },
    ng_core_DataSubjectRightsRequest: {
        id: 'ui.page.login.rtbf.text',
        defaultMessage: 'Data Subject Rights Request'
    },
    ng_core_termsAndConditionsOfUse: {
        id: 'ng_core_termsAndConditionsOfUse',
        defaultMessage: 'Terms and Conditions of Use:'
    },
    ng_core_TAC: {
        id: 'ng_core_TAC',
        defaultMessage:
            'Welcome to the OnSolve customer login site. The terms and conditions concerning your use of the site and your account are set forth in your contractual agreement with OnSolve. By accessing, using or downloading any material from the site or your account, you agree to follow and be bound by those terms and conditions.'
    },
    ng_contactUs_contactCustomerSupport: {
        id: 'ng_contactUs_contactCustomerSupport',
        defaultMessage: 'Contact Customer Support'
    },
    ng_contactUs_customerSupportAvailability: {
        id: 'ng_contactUs_customerSupportAvailability',
        defaultMessage:
            'OnSolve support is available 24x7x365. Our Customer Support team provides guidance with account management, data maintenance, best practices, and general troubleshooting.'
    },
    ng_contactUs_unitedStates: {
        id: 'ng_contactUs_unitedStates',
        defaultMessage: 'United States'
    },
    ng_contactUs_unitedKingdom: {
        id: 'ng_contactUs_unitedKingdom',
        defaultMessage: 'United Kingdom'
    },
    ng_contactUs_australia: {
        id: 'ng_contactUs_australia',
        defaultMessage: 'Australia'
    },
    ng_contactUs_northAmerica: {
        id: 'ng_contactUs_northAmerica',
        defaultMessage: 'North America'
    },
    ng_contactUs_tollFree: {
        id: 'ng_contactUs_tollFree',
        defaultMessage: 'Toll Free'
    },
    ng_contactUs_tollPhone: {
        id: 'ng_contactUs_tollPhone',
        defaultMessage: 'Toll Phone'
    },
    ng_contactUs_telephone: {
        id: 'ng_telephone',
        defaultMessage: 'Telephone'
    },
    ng_core_signedInAs: {
        id: 'ng_signedInAs',
        defaultMessage: 'Signed in as'
    },
    ng_core_signOut: {
        id: 'ng_generic_signOut',
        defaultMessage: 'Sign Out'
    },
    ng_core_signingOut: {
        id: 'ng_generic_signingOut',
        defaultMessage: 'Signing out'
    },
    ng_core_myInformation: {
        id: 'ng_myInfoMenuItem',
        defaultMessage: 'My Information'
    },
    ng_core_checkIn: {
        id: 'ng_create_role_check_in',
        defaultMessage: 'Check-In'
    },
    ng_core_checkOutDate: {
        id: 'ng_core_checkOutDate',
        defaultMessage: 'Check-Out Date'
    },
    ng_core_manageMyProfile: {
        id: 'ng_core_manageMyProfile',
        defaultMessage: 'Manage My Profile'
    },
    ng_core_passwordReset: {
        id: 'ng_core_passwordReset',
        defaultMessage: 'Password Reset'
    },
    ng_core_language: {
        id: 'ng_language',
        defaultMessage: 'Language'
    },
    ng_core_mobileApp: {
        id: 'search.field.mobileApp',
        defaultMessage: 'Mobile App'
    },
    ng_core_organization: {
        id: 'ng_organization',
        defaultMessage: 'Organization'
    },
    ng_core_httpErrorMessage: {
        id: 'ng_httpErrorMessage',
        defaultMessage: 'An error occurred when trying to load this page. Please try again.'
    },
    ng_core_weSignedYouOut: {
        id: 'ng_generic_weSignedYouOut',
        defaultMessage: 'We signed you out'
    },
    ng_core_returnToSignInEnterCreds: {
        id: 'ng_generic_returnToSignInEnterCreds',
        defaultMessage: 'Please return to the sign-in page and enter your credentials.'
    },
    ng_core_returnToSignIn: {
        id: 'ng_generic_returnToSignIn',
        defaultMessage: 'Return to sign in'
    },
    ng_core_backToSignIn: {
        id: 'ng_generic_backToSignIn',
        defaultMessage: 'Back to sign in'
    },
    ng_core_pageNotFound: {
        id: 'ng_generic_pageNotFound',
        defaultMessage: 'Page Not Found'
    },
    ng_core_refreshPage: {
        id: 'ng_generic_refreshPage',
        defaultMessage: 'Refresh page'
    },
    ng_core_backToDashboard: {
        id: 'ng_generic_backToDashboard',
        defaultMessage: 'Back to dashboard'
    },
    ng_core_forbiddenServerError: {
        id: 'ng_generic_forbiddenServerError',
        defaultMessage: 'Forbidden/Not Authorized'
    },
    ng_core_forbiddenServerErrorMessage: {
        id: 'ng_generic_forbiddenServerErrorMessage',
        defaultMessage: 'Access to this page is not authorized.'
    },
    ng_core_internalServerErrorUnauthMessage: {
        id: 'ng_generic_internalServerErrorUnauthMessage',
        defaultMessage: 'This page does not exist. Please check your URL or return to the sign in.'
    },
    ng_core_internalServerErrorAuthMessage: {
        id: 'ng_generic_internalServerErrorAuthMessage',
        defaultMessage: 'This page does not exist. Please check your URL or return to the dashboard.'
    },
    ng_core_internalServerError: {
        id: 'ng_generic_internalServerError',
        defaultMessage: 'Internal Server Error'
    },
    ng_core_internalServerErrorMessage: {
        id: 'ng_generic_internalServerErrorMessage',
        defaultMessage:
            'We have encountered an unexpected error and are working towards resolving this issue. Please try again later.'
    },
    ng_core_addRole: {
        id: 'ng_core_addRole',
        defaultMessage: 'Add Role'
    },
    ng_core_addRoleTemplate: {
        id: 'ng_core_addRoleTemplate',
        defaultMessage: 'Add Role Template'
    },
    ng_core_alertModule: {
        id: 'ng_core_alertModule',
        defaultMessage: 'Alert Module'
    },
    ng_core_alertModuleDescription: {
        id: 'ng_core_alertModuleDescription',
        defaultMessage: 'Global default settings for alerts'
    },
    ng_core_mobileDescription: {
        id: 'ng_core_mobileDescription',
        defaultMessage: 'Mobile Groups & Users'
    },
    ng_core_conferenceBridgeSettings: {
        id: 'ng_core_conferenceBridgeSettings',
        defaultMessage: 'Conference Bridge Settings'
    },
    ng_core_conferenceBridgeSettingsDescription: {
        id: 'ng_core_conferenceBridgeSettingsDescription',
        defaultMessage: 'Global default settings for internal conference bridge'
    },
    ng_core_sharedMessageBoardsDescription: {
        id: 'ng_core_sharedMessageBoardsDescription',
        defaultMessage: 'Default PIN settings for shared message boards'
    },
    ng_core_configure: {
        id: 'ng_core_configure',
        defaultMessage: 'Configure'
    },
    ng_core_integrationsDescription: {
        id: 'ng_core_integrationsDescription',
        defaultMessage: 'Social media, chat & other system integrations'
    },
    ng_core_integrationsSocialMediaDescription: {
        id: 'ng_core_integrationsSocialMediaDescription',
        defaultMessage: 'Social media, chat & other system integrations'
    },
    ng_core_selfRegDescription: {
        id: 'ng_core_selfRegDescription',
        defaultMessage: 'Portals for user-created contacts'
    },
    ng_core_permissionsDescription: {
        id: 'ng_core_permissionsDescription',
        defaultMessage: 'Access rights for user roles and contacts'
    },
    ng_core_brandingDescription: {
        id: 'ng_core_branding',
        defaultMessage: 'Logo & colors customization, terms & conditions, response options'
    },
    ng_core_modalityDescription: {
        id: 'ng_core_modality',
        defaultMessage: 'Configure default device modalities for Quick Alert'
    },
    ng_core_securityDescription: {
        id: 'ng_core_securityDescription',
        defaultMessage: 'Password and Authentication'
    },
    ng_core_subscriptions: {
        id: 'ng_core_subscriptions',
        defaultMessage: 'Subscriptions'
    },
    ng_core_textToKeyword: {
        id: 'ng_core_textToKeyword',
        defaultMessage: 'Text-to-Keyword'
    },
    ng_core_weatherAndEventsDescription: {
        id: 'ng_core_weatherAndEventsDescription',
        defaultMessage: 'Automated alerts for weather & civil emergencies'
    },
    ng_core_topicsDescription: {
        id: 'ng_core_topicsDescription',
        defaultMessage: 'Subscriptions to categories, priorities, and severities'
    },
    ng_core_textToKeywordDescription: {
        id: 'ng_core_textToKeywordDescription',
        defaultMessage: 'Opt-In to alert subscriptions with text-to-keyword'
    },
    ng_core_announcementsDescription: {
        id: 'ng_core_announcementsDescription',
        defaultMessage: 'Product updates, maintenance, & webinars from OnSolve'
    },
    ng_core_whatIsNewInBetaDescription: {
        id: 'ng_core_whatIsNewInBetaDescription',
        defaultMessage: 'Product Updates on OnSolve Platform'
    },
    ng_core_documentationDescription: {
        id: 'ng_core_documentationDescription',
        defaultMessage: 'Manuals & User Guides'
    },
    ng_core_resourceLibraryDescription: {
        id: 'ng_core_resourceLibraryDescription',
        defaultMessage: 'Training videos & documentation on OnSolve Platform'
    },
    ng_core_customLabels: {
        id: 'ng_core_customLabels',
        defaultMessage: 'Custom Labels'
    },
    ng_core_customLabelsDescription: {
        id: 'ng_core_customLabelsDescription',
        defaultMessage: 'View and manage labels.'
    },
    ng_core_globalCascadeDescription: {
        id: 'ng_core_globalCascadeDescription',
        defaultMessage: 'View and manage global cascade.'
    },
    ng_core_alertLanguagesDescription: {
        id: 'ng_core_alertLanguagesDescription',
        defaultMessage: 'View and manage alert languages.'
    },
    ng_core_alertGlobalVariablesDescription: {
        id: 'ng_core_alertGlobalVariablesDescription',
        defaultMessage: 'View and manage alert global variables.'
    },
    ng_core_audioLibraryDescription: {
        id: 'ng_core_audioLibraryDescription',
        defaultMessage: 'View and manage audio library.'
    },
    ng_core_callCenterConnectDescription: {
        id: 'ng_core_callCenterConnectDescription',
        defaultMessage: 'View and manage call center connect.'
    },
    ng_core_callForwardingDescription: {
        id: 'ng_core_callForwardingDescription',
        defaultMessage: 'View and manage call forwarding.'
    },
    ng_core_priorityDescription: {
        id: 'ng_core_priorityDescription',
        defaultMessage: 'View and manage priority.'
    },
    ng_core_smsDescription: {
        id: 'ng_core_smsDescription',
        defaultMessage: 'View and manage SMS.'
    },
    ng_core_voiceDescription: {
        id: 'ng_core_voiceDescription',
        defaultMessage: 'View and manage voice.'
    },
    ng_core_emailDescription: {
        id: 'ng_core_customFromEmailDescription',
        defaultMessage: 'View and manage email.'
    },
    ng_core_generalOptionsDescription: {
        id: 'ng_core_generalOptionsDescription',
        defaultMessage: 'View and manage general options.'
    },
    ng_core_retrySettingsDescription: {
        id: 'ng_core_retrySettingsDescription',
        defaultMessage: 'View and manage retry settings.'
    },
    ng_core_callManagement: {
        id: 'ng_core_callManagement',
        defaultMessage: 'Call Management'
    },
    ng_core_callManagementDescription: {
        id: 'ng_core_callManagementDescription',
        defaultMessage: 'View and manage call management.'
    },
    ng_core_rolesDescription: {
        id: 'ng_core_rolesDescription',
        defaultMessage: 'View and manage roles.'
    },
    ng_core_rolesAndTemplatesDescription: {
        id: 'ng_core_rolesAndTemplatesDescription',
        defaultMessage: 'View and manage Roles and Templates.'
    },
    ng_core_divisions: {
        id: 'ng_topicsList_divisions',
        defaultMessage: 'Divisions'
    },
    ng_core_divisionsDescription: {
        id: 'ng_core_divisionsDescription',
        defaultMessage: 'View and manage divisions.'
    },
    ng_core_announcementInternalTool: {
        id: 'ng_core_announcementInternalTool',
        defaultMessage: 'Announcement Internal Tool'
    },
    ng_core_announcementInternalToolDescription: {
        id: 'ng_core_announcementInternalToolDescription',
        defaultMessage: 'Internal tool for creation of OnSolve Announcements'
    },
    ng_core_showSubmenus: {
        id: 'ng_core_showSubmenus',
        defaultMessage: 'Show submenus'
    },
    ng_core_hideSubmenus: {
        id: 'ng_core_hideSubmenus',
        defaultMessage: 'Hide submenus'
    },
    ng_core_inbox: {
        id: 'ng_core_inbox',
        defaultMessage: 'Inbox'
    },
    ng_core_scenarioLibrary: {
        id: 'ng_core_scenarioLibrary',
        defaultMessage: 'Scenario Library'
    },
    ng_core_ipaws: {
        id: 'ng_core_ipaws',
        defaultMessage: 'IPAWS'
    },
    ng_core_openProfileMenu: {
        id: 'ng_core_openProfileMenu',
        defaultMessage: 'open {name} profile menu'
    },
    ng_core_openNotifications: {
        id: 'ng_core_openNotifications',
        defaultMessage: 'open {count} notifications'
    },
    ng_core_openAlerts: {
        id: 'ng_core_openAlerts',
        defaultMessage: 'open {count} alerts'
    },
    ng_core_insufficientPermission: {
        id: 'ng_core_insufficientPermission',
        defaultMessage: 'Insufficient Permission'
    },
    //TODO: This translation shouldn't have HTML inside of it.
    ng_core_insufficientPermissionDescription: {
        id: 'ng_core_insufficientPermissionDescription',
        defaultMessage: 'Contact your administrator to enable <strong>{0}</strong>.'
    },
    ng_core_goToDashboard: {
        id: 'ng_core_goToDashboard',
        defaultMessage: 'Go to Dashboard'
    },
    ng_core_staySignedIn: {
        id: 'ng_core_staySignedIn',
        defaultMessage: 'Stay signed in'
    },
    ng_core_sessionWillExpire: {
        id: 'ng_core_sessionWillExpire',
        defaultMessage: 'This Session is about to expire'
    },
    ng_core_logoutWarning: {
        id: 'ng_core_logoutWarning',
        defaultMessage:
            'You will be signed out in approximately one minute. To extend the session, select "Stay Signed In", or select "Sign Out" to end your session now.'
    },
    ng_core_addRoleDescription: {
        id: 'ng_core_addRoleDescription',
        defaultMessage: 'Add new roles.'
    },
    ng_core_addRoleTemplateDescription: {
        id: 'ng_core_addRoleTemplateDescription',
        defaultMessage: 'Add new role templates.'
    },
    ng_core_customVerbiageDescription: {
        id: 'ng_core_customVerbiageDescription',
        defaultMessage: 'View and manage custom verbiage.'
    },
    ng_core_protectedDataFieldsDescription: {
        id: 'ng_core_protectedDataFieldsDescription',
        defaultMessage: 'View and manage protected data fields.'
    },
    ng_core_divisionAniDescription: {
        id: 'ng_core_divisionAniDescription',
        defaultMessage: 'View and manage division ANI.'
    },
    ng_core_callThrottlingDescription: {
        id: 'ng_core_callThrottlingDescription',
        defaultMessage: 'View and manage call throttling.'
    },
    ng_core_suppressedAlerts: {
        id: 'ng_core_suppressedAlerts',
        defaultMessage: 'Suppressed Alerts'
    },
    ng_core_suppressedAlertsDescription: {
        id: 'ng_core_suppressedAlertsDescription',
        defaultMessage: 'View Suppressed Alerts.'
    },
    ng_core_manageBlockedSMS: {
        id: 'ng_core_manageBlockedSMS',
        defaultMessage: 'Manage Blocked SMS'
    },
    ng_core_manageBlockedSMSDescription: {
        id: 'ng_core_manageBlockedSMSDescription',
        defaultMessage: 'View and manage SMS sending rules.'
    },
    ng_core_allowedSMS: {
        id: 'ng_core_allowedSMS',
        defaultMessage: 'Allowed SMS'
    },
    ng_core_allowedSMSDescription: {
        id: 'ng_core_allowedSMSDescription',
        defaultMessage: 'View and manage allowed SMS addresses.'
    },
    ng_core_assignSMSProfiles: {
        id: 'ng_core_assignSMSProfiles',
        defaultMessage: 'Assign SMS Profiles'
    },
    ng_core_assignSMSProfilesDescription: {
        id: 'ng_core_assignSMSProfilesDescription',
        defaultMessage: 'View and manage SMS profiles.'
    },
    ng_core_editTTSVoices: {
        id: 'ng_core_editTTSVoices',
        defaultMessage: 'Edit TTS Voices'
    },
    ng_core_editTTSVoicesDescription: {
        id: 'ng_core_editTTSVoicesDescription',
        defaultMessage: 'View and manage TTS voices.'
    },
    ng_core_editPronunciations: {
        id: 'ng_core_editPronunciations',
        defaultMessage: 'Edit Pronunciations'
    },
    ng_core_editPronunciationsDescription: {
        id: 'ng_core_editPronunciationsDescription',
        defaultMessage: 'View and manage pronunciation text strings.'
    },
    ng_core_smime: {
        id: 'ng_core_smime',
        defaultMessage: 'Manage Division S/MIME Keys'
    },
    ng_core_smimeDescription: {
        id: 'ng_core_smimeDescription',
        defaultMessage: 'View and manage email S/MIME Keys.'
    },
    ng_core_moveDivisions: {
        id: 'ng_core_moveDivisions',
        defaultMessage: 'Move Divisions'
    },
    ng_core_moveDivisionsDescription: {
        id: 'ng_core_moveDivisionsDescription',
        defaultMessage: 'Manage division assignments.'
    },
    ng_core_duplicateFilters: {
        id: 'ng_core_duplicateFilters',
        defaultMessage: 'Duplicate Filters'
    },
    ng_core_duplicateFiltersDescription: {
        id: 'ng_core_duplicateFiltersDescription',
        defaultMessage: 'View and manage duplicate alert filters.'
    },
    ng_core_alertRetrieval: {
        id: 'ng_core_alertRetrieval',
        defaultMessage: 'Alert Retrieval'
    },
    ng_core_alertRetrievalDescription: {
        id: 'ng_core_alertRetrievalDescription',
        defaultMessage: 'View and manage alert retrieval settings.'
    },
    ng_core_customReports: {
        id: 'ng_core_customReports',
        defaultMessage: 'Custom Reports'
    },
    ng_core_customReportsDescriptions: {
        id: 'ng_core_customReportsDescriptions',
        defaultMessage: 'View Custom Reports'
    },
    ng_core_passwordResetError: {
        id: 'ng_core_passwordResetError',
        defaultMessage: 'The passwords entered do not match'
    },
    ng_core_alertMultipleErrors: {
        id: 'ng_core_alertMultipleErrors',
        defaultMessage: 'Correct {0} errors'
    },
    ng_core_profileHasNoAccess: {
        id: 'ng_core_profileHasNoAccess',
        defaultMessage: 'Your user profile doesn’t have permissions to this module.'
    },
    ng_core_billing_usage: {
        id: 'ng_core_billing_usage',
        defaultMessage: 'Billing Usage'
    },
    ng_core_billingUsageDescription: {
        id: 'ng_core_billingUsageDescription',
        defaultMessage: 'Track system usage for message banks'
    },
    ng_core_people_over_time: {
        id: 'ng_core_people_over_time',
        defaultMessage: 'People Over Time'
    },
    ng_core_people_over_timeDescription: {
        id: 'ng_core_people_over_timeDescription',
        defaultMessage: 'Track people added over time'
    },
    ng_core_suppressed_notification_report: {
        id: 'ng_core_suppressed_notification_report',
        defaultMessage: 'Suppressed Notification Report'
    },
    ng_core_divisionBoundaries: {
        id: 'ng_core_divisionBoundaries',
        defaultMessage: 'Division Boundaries'
    },
    ng_core_divisionBoundariesDescription: {
        id: 'ng_core_divisionBoundariesDescription',
        defaultMessage: 'Manage division boundaries.'
    },
    ng_core_subjectParamRequired: {
        id: 'ng_core_subjectParamRequired',
        defaultMessage: 'subject_sub param required.'
    },
    ng_core_specifiedUserNotFound: {
        id: 'ng_core_specifiedUserNotFound',
        defaultMessage: 'The specified user not found.'
    },
    ng_core_providedUserIsLocked: {
        id: 'ng_core_providedUserIsLocked',
        defaultMessage: 'Provided User is locked.'
    },
    ng_core_userNotPermittedForAction: {
        id: 'ng_core_userNotPermittedForAction',
        defaultMessage: 'User is not permitted to perform the action'
    },
    ng_core_invalidActorToken: {
        id: 'ng_core_invalidActorToken',
        defaultMessage: 'actor_token is invalid, rejecting.'
    },
    ng_core_invalidActorTokenType: {
        id: 'ng_core_invalidActorTokenType',
        defaultMessage: 'Only urn:ietf:params:oauth:token-type:access_token is supported as actor_token_type'
    },
    ng_core_unauthorizedUserImpersonationRequest: {
        id: 'ng_core_unauthorizedUserImpersonationRequest',
        defaultMessage:
            'To access the View as User feature, the user you are trying to view must have a role that has Web UI permissions.'
    },
    ng_core_poweredByOnSolve: {
        id: 'ng_core_poweredByOnSolve',
        defaultMessage: 'Powered by OnSolve'
    },
    ng_core_resourceLibrary_underConstructionMsg: {
        id: 'ng_core_resourceLibrary_underConstructionMsg',
        defaultMessage: 'We are transitioning to a new {0}. Stay tuned!'
    },
    ng_core_BIReporting: {
        id: 'ng_core_BIReporting',
        defaultMessage: 'BI Reporting'
    },
    ng_core_BIReportingDescription: {
        id: 'ng_core_BIReportingsDescription',
        defaultMessage: 'View simple and complex reports across all event data.'
    },
    ng_core_suppressReporting: {
        id: 'ng_core_suppressReporting',
        defaultMessage: 'Suppressed Alerts'
    },
    ng_core_suppressReportingDescription: {
        id: 'ng_core_suppressReportingDescription',
        defaultMessage: 'View records of notifications that have been suppressed.'
    },
    ng_core_travel: {
        id: 'ng_core_travel',
        defaultMessage: 'Travel'
    },
    ng_core_travelDescription: {
        id: 'ng_core_travelDescription',
        defaultMessage: 'Manage TRM related settings'
    },
    ng_core_sameFlightAlerts: {
        id: 'ng_core_sameFlightAlerts',
        defaultMessage: 'Same Flight Alerts'
    },
    ng_core_highRiskTravelAlerts: {
        id: 'ng_core_highRiskTravelAlerts',
        defaultMessage: 'High Risk Travel Alerts'
    },
    ng_core_sameFlightAlerts_description: {
        id: 'ng_core_sameFlightAlerts_description',
        defaultMessage: 'Notifications for a threshold number of people on the same flight.'
    },
    ng_core_highRiskTravelAlerts_description: {
        id: 'ng_core_highRiskTravelAlerts_description',
        defaultMessage: 'Notifications for trips to high risk destinations.'
    },
    ng_core_oneWayTrips: {
        id: 'ng_core_oneWayTrips',
        defaultMessage: 'Trip Display Settings'
    },
    ng_core_cascadingUserSearch: {
        id: 'ng_core_cascadingUserSearch',
        defaultMessage: 'Cascading User Search'
    },
    ng_core_cascadeEnabledNewUsersWillBeCreated: {
        id: 'ng_core_cascadeEnabledNewUsersWillBeCreated',
        defaultMessage: 'Cascade Enabled | New users will be created in <strong>{0}</strong>'
    },
    ng_core_usersNotFoundWillBeCreatedInDivision: {
        id: 'ng_core_usersNotFoundWillBeCreatedInDivision',
        defaultMessage: 'Users that are not found will be created in the {0} division'
    },
    ng_core_tripDisplaySettingsSubtext: {
        id: 'ng_core_tripDisplaySettingsSubtext',
        defaultMessage: 'Configure display settings for travelers on the Control Center map.'
    },
    ng_core_configureItineraryIngestionBehaviour: {
        id: 'ng_core_configureItineraryIngestionBehaviour',
        defaultMessage: 'Configure itinerary ingestion behavior.'
    },
    ng_noAccessToConfigure: {
        id: 'ng_noAccessToConfigure',
        defaultMessage: 'You must have a Risk Intelligence role of Administrator to configure this alert. '
    },
    ng_noAccessToOneWayTripsConfigIfNotOrgAdmin: {
        id: 'ng_noAccessToOneWayTripsConfigIfNotOrgAdmin',
        defaultMessage: 'You must have a user role of Organization Admin to configure One Way Trips. '
    },
    ng_noAccessToCascadingUserSearchConfigIfNotOrgAdmin: {
        id: 'ng_noAccessToCascadingUserSearchConfigIfNotOrgAdmin',
        defaultMessage: 'You must have a user role of Organization Admin to configure Cascading User Search.'
    },
    ng_parentDivisionsAreAppliedToChildDivisions: {
        id: 'ng_parentDivisionsAreAppliedToChildDivisions',
        defaultMessage: 'Parent division defaults are automatically applied to child divisions.'
    },
    ng_pleaseSelectTheDivisionWhereUsersWillBeCreated: {
        id: 'ng_pleaseSelectTheDivisionWhereUsersWillBeCreated',
        defaultMessage: 'Please select the division where users will be created if they are not found.'
    },
    ng_pleaseSelectTheDivisionWhereTheCascadeBegin: {
        id: 'ng_pleaseSelectTheDivisionWhereTheCascadeBegin',
        defaultMessage: 'Please select the division where the cascade search should begin.'
    },
    ng_core_sameFlightAlertTitle: {
        id: 'ng_core_sameFlightAlertTitle',
        defaultMessage: 'Create Same Flight Alert'
    },
    ng_core_highRiskTravelAlertTitle: {
        id: 'ng_core_highRiskTravelAlertTitle',
        defaultMessage: 'Create High Risk Travel Alert'
    },
    ng_core_contactSupportTileDescription: {
        id: 'ng_core_contactSupportTileDescription',
        defaultMessage: 'Contact Customer Support for Onsolve'
    },
    ng_core_shapesLibrary: {
        id: 'ng_core_shapesLibrary',
        defaultMessage: 'Shapes Library'
    }
});

export default coreTranslations;
